import { render, staticRenderFns } from "./VlContactDataElement.vue?vue&type=template&id=6fee31d7&scoped=true&"
import script from "./VlContactDataElement.vue?vue&type=script&lang=js&"
export * from "./VlContactDataElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee31d7",
  null
  
)

export default component.exports